<template>
  <div
    ref="bar"
    class="barGaugeBackground"
  >
    <div
      class="barGaugeForeground"
      :style="{width: percentileBarWidth}"
    />
    <div class="barLabel">
      {{ percentileLabel }}
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'PercentileBar',
  props: {
    percentile: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      barWidth: 0,
    }
  },
  computed: {
    ...mapState({
      windowWidth: state => state.appFrame.windowWidth,
    }),
    percentileOrdinal: function () {
      return this.percentile + 'th'
    },
    percentileLabel: function () {
      return this.percentileOrdinal + ' percentile'
    },
    percentileBarWidth: function () {
      var barWidth = this.barWidth + (this.windowWidth - this.windowWidth) // force updates on window resize
      if (this.$refs.bar) {
        barWidth = this.$refs.bar.offsetWidth // except before we've rendered once, this will execute
      }
      return this.percentile * barWidth / 100 + 'px'
    },
  },
  mounted: function () {
    this.barWidth = this.$refs.bar.offsetWidth
  },
}

</script>
